import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';

export const LS_LAST_MANUAL_CLOUD_TYPE = 'lastCloudTypeManualJobs';
export const REAL_DEVICE_CLOUD = 'real_device_cloud';
export const VIRTUAL_DEVICE_CLOUD = 'virtual_device_cloud';

export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE = 1;
export const JOB_PAGE_SIZES = [25, 50, 75, 100];

export const CLOUD_TYPES = [
  ...(isSupportedFeature(features.VDC) ? [VIRTUAL_DEVICE_CLOUD] : []),
  ...(isSupportedFeature(features.RDC) ? [REAL_DEVICE_CLOUD] : []),
];
export const DEFAULT_CLOUD_TYPE = CLOUD_TYPES.find((ct) => ct);

export const TAB_REAL = 'rdc';
export const TAB_VIRTUAL = 'vdc';
export const DEFAULT_TAB = TAB_VIRTUAL;
export const TABS = {
  [TAB_REAL]: REAL_DEVICE_CLOUD,
  [TAB_VIRTUAL]: VIRTUAL_DEVICE_CLOUD,
};
export const CLOUD_TAB_TYPES = [TAB_REAL, TAB_VIRTUAL];

export const defaultParams = {
  [REAL_DEVICE_CLOUD]: {
    type: ['LIVE', 'VIRTUAL_USB'],
  },
  [VIRTUAL_DEVICE_CLOUD]: {
    manual_only: true,
    full: true,
  },
};
